export const SET_UPLOAD_FILE = 'SET_UPLOAD_FILE';
export const SET_UPLOAD_URL = 'SET_UPLOAD_URL';
export const SET_VOD_LAYOUT_OPEN = 'SET_VOD_LAYOUT_OPEN';
export const SET_FOCUS_VOD_UUID = 'SET_FOCUS_VOD_UUID';
export const SET_VOD_LIST = 'SET_VOD_LIST';
export const DEL_VOD_LIST = 'DEL_VOD_LIST';